import axios from "axios";

//根据产品编码推荐同类型的产品
export function getCredentialTypeBySku(code, num) {
  return axios.get(`/w1/goods/getCredentialTypeBySku/${code}`);
}
